export default "__VITE_ASSET__30ccff7f__"